/*All Submission Page*/
import Service from "../Service/http";
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import { FiRefreshCcw } from "react-icons/fi";

const ReactTableFixedColumns = withFixedColumns(ReactTable);

function AllSubmission(prop){

  let service = new Service();
  let [data, setData] = useState([]); /*Table data*/
  let [pageData, setPageData] = useState([]); /*Meta Data about pages*/
  let [color, Setcolor] = useState('');
  let [background, SetBackground] = useState("#81C784");
  let [textColor, SetTextcolor] = useState("");

  /*Tells when the api need to be called*/
  let [getApi, setGetApi] = useState(0);

  /*Value of the filter applied*/
  let [userFilterValue, setuserFilterValue] =useState("");
  let [problemFilterValue, setproblemFilterValue] =useState("");
  let [verdictFilterValue, setverdictFilterValue] =useState("All");
  let [languageFilterValue, setlanguageFilterValue] =useState("All");

  /*Determines wether it is AllSubmissions page for admin or AllSubmissions page for user*/
  let [isAdmin, setIsAdmin] = useState(false);

  /*List for Filter Dropdown*/
  let [verdicts, setVerdict] = useState(['All',"ACCEPTED", "WRONG ANSWER","TIME LIMIT EXCEEDED","RUNTIME ERROR","PENDING","OTHER","COMPILATION ERROR"]);
  let [languages, setLanguage] = useState(['All',"CPP", "C#", "JAVA", "JAVASCRIPT", "PYTHON"]);
  
  /*Pagination Data*/
  let [pageNo, setPageNo]=useState(1);
  let [perPage, setPerPage]=useState(5);

  const getDelay = (time) => {
    return new Promise(resolve => setTimeout(resolve, time));
  }

  /*Get Data from Api*/
  useEffect(() => {
    service
    .get("api/allSubmissions?name="+userFilterValue+'&problem='+problemFilterValue+'&verdict='+verdictFilterValue+'&lang='+languageFilterValue+'&page='+pageNo+"&perPage="+perPage)
    .then((json)=>{
      setIsAdmin(json['meta']['role']==='admin'?true:false);
      let st = false;
      let result = [];
      let ind = ((json['meta']['currentPage']-1)*(json['meta']['perPage'])+1)
      for(var ele of json['submissions']){
        let temp = {};      
        temp['no']=ind;
        temp['name'] = ele['username']['name'];
        temp['problem']=ele['problemname']['title'];
        temp['verdict'] = ele['verdict_string'];
        temp['lang'] = ele['language'];
        temp['timestamp'] = new Date(ele['createdAt']).toLocaleString();
        temp['verdictURL'] = '/submission/'+ele['_id'];
        temp['userURL'] = '/coding/profile/'+ele['username']['_id']
        temp['problemURL'] = '/code/'+ele['problemname']['id_number']
        temp['polling'] = ele['is_server_polling'];
        temp['submission_id'] = ele['_id'];
        if (temp['polling']){
          st = true;
          setAny_submission_polling(true);
        }
        result.push(temp);
        ind++;
      }
        setData(result);
        setPageData(json['meta']);    
    })
    .catch((error)=>{
      console.log(error);
    })
  },[getApi])

  const handleChange = (e, v) => {
    setPageNo(v);
    setGetApi(getApi+1);
  };

  const originalWarn = console.warn;
  console.warn = function (...args) {
      const arg = args && args[0];
      if (arg && arg.includes('Attempting to load version \'51\' of Google Charts')) return;
      originalWarn(...args);
  };

  const [any_submission_polling,setAny_submission_polling] = useState(false);

  const reEvalSubmission = async (id,verdict) =>{
    if (verdict == "PENDING"){
      service.get("api/re-evaluate/submission/old/"+id);
    }
    else{
      service.get("api/re-evaluate/submission/new/"+id);
    }
    await getDelay(10000);
    updateAllSubmission();
  }

  const updateAllSubmission = async () =>{
    const json = await service
    .get("api/allSubmissions?name="+userFilterValue+'&problem='+problemFilterValue+'&verdict='+verdictFilterValue+'&lang='+languageFilterValue+'&page='+pageNo+"&perPage="+perPage);
    let result = []
    let st = false;
    let ind = ((json['meta']['currentPage']-1)*(json['meta']['perPage'])+1)
    for await (var ele of json['submissions']){
      let temp = {};
      temp['no']=ind;
      temp['name'] = ele['username']['name'];
      temp['problem']=ele['problemname']['title'];
      temp['verdict'] = ele['verdict_string'];
      temp['lang'] = ele['language'];
      temp['timestamp'] = new Date(ele['createdAt']).toLocaleString();
      temp['verdictURL'] = '/submission/'+ele['_id'];
      temp['userURL'] = '/coding/profile/'+ele['username']['_id'];
      temp['problemURL'] = '/code/'+ele['problemname']['id_number'];
      temp['polling'] = ele['is_server_polling'];
      temp['submission_id'] = ele['_id'];
      if (temp['polling']){
        st = true;
        setAny_submission_polling(true);
      } 
      result.push(temp);
      ind++;
    }
    setData(result);
    setPageData(json['meta']);
    if (any_submission_polling || st){
      await getDelay(30000);
      updateAllSubmission();
    }
    else if (st == false){
      await getDelay(30000);
      setAny_submission_polling(false);
    }
  }

  /*First api call*/
  useEffect(() => {
    service
      .get("api/allSubmissions?name="+userFilterValue+'&problem='+problemFilterValue+'&verdict='+verdictFilterValue+'&lang='+languageFilterValue+'&page='+pageNo+"&perPage="+perPage)
      .then((json)=>{
        let result = []
        let st = false;
        let ind = ((json['meta']['currentPage']-1)*(json['meta']['perPage'])+1)
        for(var ele of json['submissions']){
          let temp = {};
          temp['no']=ind;
          temp['name'] = ele['username']['name'];
          temp['problem']=ele['problemname']['title'];
          temp['verdict'] = ele['verdict_string'];
          temp['lang'] = ele['language'];
          temp['timestamp'] = new Date(ele['createdAt']).toLocaleString();
          temp['verdictURL'] = '/submission/'+ele['_id'];
          temp['userURL'] = '/coding/profile/'+ele['username']['_id'];
          temp['problemURL'] = '/code/'+ele['problemname']['id_number']
          temp['polling'] = ele['is_server_polling'];
          temp['submission_id'] = ele['_id'];
          if (temp['polling']){
            st = true;
            setAny_submission_polling(true);
          } 
          result.push(temp);
          ind++;
        }
        setData(result);
        setPageData(json['meta']);
        if (any_submission_polling || st){
          updateAllSubmission();
        }
      })
      .catch((error)=>{
        console.log(error);
      })
  }, []);
 
  return (
    <div className="">
      <ReactTableFixedColumns
        sortable={false}
        data={data}
        pageSize={data?.length || perPage}
        showPagination={false}
        style={{fontWeight: "bold"}}
        columns={[
            {
                Header: "No",
                accessor: "no",
                getProps: (state, rowInfo, column) => {
                return {
                    style: {
                          color: (rowInfo?.original?.my) ?  color : textColor,
                          background: rowInfo?.original?.my ? "#E8E8E8" : "#E8E8E8" ,
                        },
                      };
                    },
                   minWidth: 50
              },
          {
            Header: () => (<div>User<br/> {isAdmin ?<input type="text" id="search_user" name="search_user"  onKeyPress={(e)=>{if(e.key==="Enter"){setGetApi(getApi+1)}}}onChange={(e)=>{setuserFilterValue(e.target.value);}}/>:''}</div>),
            accessor: "name",
            disableSortBy: true,
            Cell: e =><a href={e.original.userURL} color={textColor}> {e.original.name} </a>,
            getProps: (state, rowInfo, column) => {
            return {
                style: {
                      color: (rowInfo?.original?.my) ? 'white' : 'white',
                      background: rowInfo?.original?.my ? "#E8E8E8" : "#E8E8E8",  
                    },
                  };
                }, 
                minWidth: 237
            }, 
            {
                Header: () => (<div>Problem<br/><input type="text" id="problem" name="problem"  onKeyPress={(e)=>{if(e.key==="Enter"){setGetApi(getApi+1)}}}onChange={(e)=>{setproblemFilterValue(e.target.value);}}/></div>),
                accessor: "problem",
                Cell: e =><a href={e.original.problemURL} color={textColor}> {e.original.problem} </a>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (rowInfo?.original?.my) ? 'white' : 'white',
                      background: rowInfo?.original?.my ? "#E8E8E8" : "#E8E8E8",
                    },
                  };
                },
                minWidth: 420
              },
              {  
                Header: () => (<div>Verdict<br/><select id="verdict" onChange={(e) => {setverdictFilterValue(e.target.value); setGetApi(getApi+1)}} >{verdicts.map(verdict => {return (<option value={verdict}> {verdict} </option>)})}</select></div>),
                accessor: "verdict",
                Cell: e => {
                return(
                  <div>
                  {e.original.polling?
                    <ClipLoader style={{
                      marginTop : "1rem !important"
                    }} color="#4169E1" size="16" />:
                  e.original.polling == false && (e.original.verdict == 'PENDING')?
                  <FiRefreshCcw onClick={() =>{
                    let dummy = [...data];
                    dummy[e.original.no-1]['verdict'] = "PENDING";
                    dummy[e.original.no-1]['polling'] = true;
                    setData(dummy);
                    reEvalSubmission(e.original.submission_id, e.original.verdict);
                   }} title="Refresh" style={{cursor: "pointer", display:"inline", marginBottom: ".3rem"  }} 
                     color="#FFC000" size="18" />: 
                     e.original.polling == false && e.original.verdict == 'SERVER ERROR'?
                     <FiRefreshCcw onClick={() =>{
                      let dummy = [...data];
                      dummy[e.original.no-1]['verdict'] = "PENDING";
                      dummy[e.original.no-1]['polling'] = true;
                      setData(dummy);
                      reEvalSubmission(e.original.submission_id, e.original.verdict);
                      e.original.verdict = "PENDING";
                     }} title="Re-evaluate" style={{cursor: "pointer", display:"inline", marginBottom: ".3rem" }} 
                     color="#FFC000" size="18" />: null}
                <a href={e.original.verdictURL} style={{textDecoration: 'none !important', color:  e.original.verdict === 'ACCEPTED' ? "#76B947" : e.original.verdict =='PENDING' || e.original.verdict =='SERVER ERROR' ? textColor :  "#E43D40"}} target="_blank"> {e.original.verdict} </a>
                </div>
              );
            },
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: rowInfo?.original?.verdict === 'ACCEPTED' ? "#76B947" : rowInfo?.original?.verdict =='PENDING' || rowInfo?.original?.verdict =='SERVER ERROR' ? "#B2EBF2" :  "#E43D40",
                      background: rowInfo?.original?.my ? "#E8E8E8" : "#E8E8E8",
                    },
                  };
                },
                minWidth: 210
              },
              {
                Header: () => (<div>Language<br/><select id="language" onChange={(e) => {setlanguageFilterValue(e.target.value);setGetApi(getApi+1);}}>{languages.map(language => {return (<option value={language}> {language} </option>)})}</select></div>),
                accessor: "lang",
                Cell: e =><a href={e.original.verdictURL} color={textColor} target="_blank"> {e.original.lang} </a>,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (rowInfo?.original?.my) ? color : textColor,
                      background: rowInfo?.original?.my ? "#E8E8E8" : "#E8E8E8",
                    },
                  };
                },
                minWidth: 140
              },
              {
                Header: "Time",
                accessor: "timestamp",
                sortable: true,
                getProps: (state, rowInfo, column) => {
                  return {
                    style: {
                      color: (rowInfo?.original?.my) ? color : textColor,
                      background: rowInfo?.original?.my ? "#E8E8E8" : "#E8E8E8",
                    },
                  };
                },
                minWidth: 220
              },          
        ]}
        className=" -highlight text-dark h5"
      />
      <Stack className="float-end" spacing={2}>
                  <Pagination
                    count={pageData['totalPages']}
                    color="primary"
                    defaultPage={1}
                    page={pageNo}
                    onChange={handleChange}
                  />
      </Stack>
      <div><select name="pagesize" id="pagesize" onChange={(e)=>{setPerPage(e.target.value);setGetApi(getApi+1);}}><option value={5}>5</option><option value={10}>10</option><option value={20}>20</option><option value={50}>50</option><option value={100}>100</option></select></div>
    </div>
  );
}
export default AllSubmission;